import { type QueryHookOptions, useQuery } from "@apollo/client";
import { DashboardQuery } from "../graphql/queries";
import type {
  DashboardQueryType,
  DashboardQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useDashboardQuery = (
  options?: QueryHookOptions<DashboardQueryType, DashboardQueryVariablesType>
) => {
  return useQuery<DashboardQueryType, DashboardQueryVariablesType>(
    DashboardQuery,
    options
  );
};
